"use strict";

export function initBanner() {
  $("#banner-container").load('../../components/banner.html', function () {
   
    const page = window.location.pathname.split('/').pop().replace('.html', '');
    const isPlay = (page === 'index' || page === '');

    const $arbre_trace_svg = $('#arbre_trace_svg');
    const $arbre_fleuri_svg = $('#arbre_fleuri_svg');
    if (isPlay) {
      $('#arbre_trace_svg').on('animationend', function() {
        $(this).hide();
        $('#arbre_fleuri_svg').show();
      });
    } else {
      $arbre_trace_svg.hide();
      $arbre_fleuri_svg.show();
    }
  });
  console.log("fin : initBanner")
}